/* =====================================================================
   AIRFORCE · Shopify runtime (runs after af-core.js)
   - real cart (Shopify AJAX Cart API) behind the same cart drawer
   - bike + build go on each line as line-item properties
   - page links, menu links and forms point at the real store
   ===================================================================== */
(function () {
  "use strict";
  var AF = window.AF, D = window.AF_DATA, S = window.AF_SHOP;
  if (!AF || !S) return;
  var P = S.products || {}, U = S.urls || {};
  var root = (U.home || "/").replace(/\/$/, "");
  /* the US note only shows to visitors Shopify places in the US */
  if (S.settings && S.settings.country && S.settings.country !== "US") AF.usNote = function () { return ""; };

  /* ---------- links: preview file names -> store URLs ---------- */
  var KIT = window.AF_KIT_PRODUCT || {};
  function mapHref(h) {
    if (!h) return h;
    var m = h.match(/^(index|product|builder|gallery|about)\.html(\?[^#]*)?(#.*)?$/); if (!m) return h;
    var q = m[2] || "", hash = m[3] || "";
    if (m[1] === "index") return (U.home || "/") + hash;
    if (m[1] === "builder") return (U.builder || "/pages/power-builder") + q + hash;
    if (m[1] === "gallery") return (U.gallery || "/pages/gallery") + hash;
    if (m[1] === "about") return (U.about || "/pages/about") + hash;
    var v = (q.match(/variant=([\w-]+)/) || [])[1], pr = v && P[KIT[v]];
    return (pr ? pr.url : U.stack || "/collections/all") + hash;
  }
  function fixLinks(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches("a[href]")) { var h0 = scope.getAttribute("href"), n0 = mapHref(h0); if (n0 !== h0) scope.setAttribute("href", n0); }
    (scope.querySelectorAll ? scope : document).querySelectorAll('a[href$=".html"], a[href*=".html#"], a[href*=".html?"]').forEach(function (a) {
      var h = a.getAttribute("href"), n = mapHref(h); if (n !== h) a.setAttribute("href", n);
    });
    if (S.imgOverride) (scope.querySelectorAll ? scope : document).querySelectorAll("img[src]").forEach(function (img) {
      var src = img.getAttribute("src");
      Object.keys(S.imgOverride).forEach(function (k) { if (src.indexOf("/" + k) > -1 && S.imgOverride[k]) img.setAttribute("src", S.imgOverride[k]); });
    });
  }
  fixLinks(document);
  new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) fixLinks(n); }); }); })
    .observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- "coming soon" links in the preview -> real destinations ---------- */
  var SOON = {
    "all products": U.allProducts, "search": U.search, "account": U.account, "learn": U.blog, "all guides": U.blog,
    "power packages": (U.home || "/") + "#sec-packages", "fenders": U.fenders || (U.home || "/") + "#sec-fender", "dirt bike": U.allProducts,
    "outerwear & filters": (P.outerwear && P.outerwear.url) || U.allProducts, "snowbike kits": U.allProducts, "fitment finder": U.stack ? U.stack + "#pdp-tabs" : U.allProducts,
    "faq": (U.home || "/") + "#faq", "shipping & returns": U.refund, "contact": "mailto:" + D.brand.email, "order status": U.account, "read the full science": U.stack,
    "shop fenders": U.fenders || (U.search || "/search") + "?type=product&q=fender", "velocity stacks": U.stack || U.allProducts, "reorder outerwear": (P.outerwear && P.outerwear.url) || U.allProducts
  };
  document.addEventListener("click", function (e) {
    var s = e.target.closest("[data-soon]"); if (!s) return;
    /* data-soon="power packages" names the destination; otherwise it's worked out from the link text */
    var key = (s.getAttribute("data-soon") || "").trim().toLowerCase() ||
      (s.getAttribute("aria-label") || s.textContent || "").trim().toLowerCase().replace(/\s+/g, " ").replace(/^.*?(\b[a-z&' ]+)$/, "$1").trim();
    var keys = Object.keys(SOON).sort(function (x, y) { return y.length - x.length; });
    var hit = SOON[key] || keys.filter(function (k) { return key.indexOf(k) === 0; }).map(function (k) { return SOON[k]; })[0] ||
      keys.filter(function (k) { return key.indexOf(k) > -1; }).map(function (k) { return SOON[k]; })[0];
    e.stopImmediatePropagation(); e.preventDefault();
    location.href = hit || U.allProducts || "/collections/all";
  }, true);
  var faq = document.querySelector('[data-section="faq"]'); if (faq && !faq.id) faq.id = "faq";

  /* ---------- forms: newsletter + email forms post to Shopify ---------- */
  document.addEventListener("submit", function (e) {
    var f = e.target.closest("[data-fake-form]"); if (!f) return;
    e.stopImmediatePropagation();
    var isSub = f.classList.contains("af-footer__sub");
    f.setAttribute("method", "post"); f.setAttribute("action", (root || "") + "/contact#" + (isSub ? "af-sub" : "af-contact")); f.setAttribute("accept-charset", "UTF-8");
    var add = function (n, v) { var i = document.createElement("input"); i.type = "hidden"; i.name = n; i.value = v; f.appendChild(i); };
    add("form_type", isSub ? "customer" : "contact"); add("utf8", "✓");
    if (isSub) add("contact[tags]", "newsletter"); else add("contact[Subject]", f.getAttribute("data-fake-form-subject") || document.title);
    Array.prototype.forEach.call(f.querySelectorAll("input,select,textarea"), function (el) {
      if (el.name || el.type === "hidden" || el.type === "submit") return;
      var lab = el.id && f.querySelector('label[for="' + el.id + '"]');
      el.name = el.type === "email" ? "contact[email]" : "contact[" + ((lab && lab.textContent.trim()) || el.placeholder || el.id || "field") + "]";
    });
  }, true);
  if (/[?&](customer_posted|contact_posted)=true/.test(location.search)) setTimeout(function () { AF.toast(/customer_posted/.test(location.search) ? "Subscribed. Watch your inbox." : "Thanks. We'll get back to you by email."); }, 400);

  /* ---------- cart: Shopify AJAX Cart API behind the existing drawer ---------- */
  var cartUrl = function (p) { return (root || "") + p; };
  function variantFor(l) {
    if (l.variant) return l.variant;
    var k = l.key || "", part, pr;
    if (k.indexOf("pb-") === 0) { part = AF.part(k.slice(3)); return part && part.shopify ? part.shopify.variant : null; }
    if (k.indexOf("kit-") === 0) { var kv = (D.stackKit.variants || []).filter(function (v) { return v.id === k.slice(4); })[0]; return kv && kv.shopify ? kv.shopify.variant : null; }
    if (k === "tune") { part = AF.part("tune"); return part && part.shopify ? part.shopify.variant : null; }
    if (k.indexOf("ow-") === 0) {
      pr = P.outerwear; if (!pr || !pr.variants) return null;
      var make = k.slice(3), want = { ktm: /ktm|husq|gas/i, yamaha: /yamaha/i, honda: /honda/i, "beta-sherco": /beta|sherco/i }[make];
      var hit = want && pr.variants.filter(function (v) { return want.test(v.title); })[0];
      return (hit || pr.variants[0]).id;
    }
    return null;
  }
  function props(l) {
    var o = {};
    if (l.bike) o.Bike = l.bike;
    (l.props || []).forEach(function (p) { o[p[0]] = p[1]; });
    if (l.needsBike) o._needs_bike = "1";
    return o;
  }
  function kitVariants() { return ["stack_ktm", "stack_yamaha", "stack_honda", "stack_beta"].reduce(function (a, k) { return a.concat(((P[k] || {}).variants || []).map(function (v) { return v.id; })); }, []); }
  function partVariants() { return D.parts.filter(function (p) { return p.shopify; }).map(function (p) { return p.shopify.variant; }); }
  function sameProduct(id, it) {
    var p = AF.part(id); if (!p || !p.shopify) return false;
    var pr = P[p.shopify.product];
    return p.shopify.variant === it.variant_id || !!(pr && pr.handle && pr.handle === it.handle) || !!(pr && pr.variants && pr.variants.some(function (v) { return v.id === it.variant_id; }));
  }
  function mapItem(it) {
    var pp = it.properties || {}, shown = Object.keys(pp).filter(function (k) { return k.charAt(0) !== "_" && k !== "Bike" && pp[k]; });
    return { key: it.key, name: it.product_title, meta: it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "", price: it.final_line_price / 100 / it.quantity,
      img: it.image ? it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=160" : null, qty: it.quantity, bike: pp.Bike || null, needsBike: !!pp._needs_bike,
      isKit: kitVariants().indexOf(it.variant_id) > -1, isPart: partVariants().indexOf(it.variant_id) > -1,
      /* match on the linked product, not just one variant, so any variant of the AiM ECU / tune / bridge counts */
      isTune: sameProduct("tune", it), isEcu: sameProduct("ecu", it), isBridge: sameProduct("bridge", it),
      partId: (D.parts.filter(function (p) { return p.shopify && (p.shopify.variant === it.variant_id || (P[p.shopify.product] && P[p.shopify.product].handle === it.handle)); })[0] || {}).id || null,
      props: shown.map(function (k) { return [k, pp[k]]; }), warn: null, handle: it.handle, variant: it.variant_id };
  }
  var C = AF.cart;
  C.items = [];
  C.raw = null;
  C.refresh = function (open) {
    return fetch(cartUrl("/cart.js"), { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (cart) {
      C.raw = cart; C.items = (cart.items || []).map(mapItem); C.render(); if (open) AF.open("af-cart"); return cart;
    }).catch(function () { C.render(); });
  };
  C.save = function () { C.render(); };
  /* Add lines to the Shopify cart. Shopify rejects the whole batch if one item can't be added (sold out, not on the
     Online Store channel), so on an error each item is tried on its own and the cart says exactly what didn't go in. */
  var post = function (items) {
    return fetch(cartUrl("/cart/add.js"), { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }, function () { if (!r.ok) throw {}; return {}; }); });
  };
  C.add = function (lines) {
    var items = [], names = [], missing = [], failed = [];
    var sl = AF.stockLines(lines); lines = sl.keep; failed = sl.out.slice();   /* sold out: held back with the lead time; out of stock: lead time on the line */
    C.notice = null;
    lines.forEach(function (l) { var v = variantFor(l); if (v) { items.push({ id: v, quantity: l.qty || 1, properties: props(l) }); names.push(l.name); } else missing.push(l.name); });
    var done = function () {
      var bits = missing.map(function (n) { return "<b>" + AF.esc(n) + "</b> (not set up in the store yet)"; })
        .concat(failed.map(function (f) { return "<b>" + AF.esc(f.name) + "</b>" + (f.why ? " (" + AF.esc(f.why) + ")" : ""); }));
      if (bits.length) {
        C.notice = "Couldn't add " + bits.join(", ") + ". Email " + AF.emailLink("Order: " + missing.concat(failed.map(function (f) { return f.name; })).join(", ")) + " to order " + (bits.length > 1 ? "them" : "it") + ".";
        /* after the caller's "Added ..." toast, so a part that didn't go in never reads as added */
        setTimeout(function () { AF.toast(bits.length + (bits.length > 1 ? " items" : " item") + " couldn't be added. See your cart."); }, 0);
      }
      return C.refresh(true);
    };
    if (!items.length) return done();
    var qmap = function (cart) { var m = {}; ((cart && cart.items) || []).forEach(function (x) { m[x.variant_id] = (m[x.variant_id] || 0) + x.quantity; }); return m; };
    var before = qmap(C.raw);
    return post(items).then(done, function () {
      /* only retry what didn't go in, in case Shopify added part of the batch */
      return fetch(cartUrl("/cart.js"), { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (cart) {
        var after = cart ? qmap(cart) : before, left = [], leftNames = [];
        items.forEach(function (it, i) { if ((after[it.id] || 0) < (before[it.id] || 0) + it.quantity) { left.push(it); leftNames.push(names[i]); } });
        items = left; names = leftNames;
      }).then(function () { return items.reduce(function (chain, it, i) {
        return chain.then(function () { return post([it]).catch(function (err) { failed.push({ name: names[i], why: err && (err.description || err.message) }); }); });
      }, Promise.resolve()); }).then(done);
    });
  };
  C.remove = function (key) {
    return fetch(cartUrl("/cart/change.js"), { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(function () { return C.refresh(); });
  };
  C.clear = function () {
    C.notice = null;
    return fetch(cartUrl("/cart/clear.js"), { method: "POST", headers: { Accept: "application/json" } }).then(function () { return C.refresh(); });
  };
  C.setQty = function (key, n) {
    return fetch(cartUrl("/cart/change.js"), { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: Math.max(0, n) }) })
      .then(function () { return C.refresh(); });
  };
  C.setProps = function (key, o) {
    var it = (C.raw && C.raw.items || []).filter(function (x) { return x.key === key; })[0]; if (!it) return Promise.resolve();
    var pr = Object.assign({}, it.properties || {}, o);
    return fetch(cartUrl("/cart/change.js"), { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: it.quantity, properties: pr }) })
      .then(function () { return C.refresh(); });
  };
  C.total = function () { return C.raw ? C.raw.total_price / 100 : 0; };
  C.count = function () { return C.raw ? C.raw.item_count : 0; };
  C.refresh();
  document.addEventListener("DOMContentLoaded", function () { C.refresh(); });
  document.addEventListener("click", function (e) {
    var ck = e.target.closest("[data-checkout]");
    if (ck) { e.stopImmediatePropagation(); if (!C.checkoutGate()) return; location.href = cartUrl("/checkout"); }
  }, true);

  /* the /cart page checkout runs the same checks as the drawer (ECU, tune) */
  document.addEventListener("submit", function (e) {
    var f = e.target; if (!f.matches || !f.matches('form[action$="/cart"]')) return;
    var sub = e.submitter; if (!sub || sub.name !== "checkout") return;
    if (C.ecuGap() || (C.tuneNudge() && !C.noTuneOk())) { e.preventDefault(); AF.open("af-cart"); C.checkoutGate(); }
  }, true);

  /* garage bike: saved as a cart attribute, and filled in on tune/ECU lines that are missing it */
  document.addEventListener("af:garage", function (e) {
    var g = e.detail; if (!g) return; var label = AF.garage.label(g);
    fetch(cartUrl("/cart/update.js"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { "Garage bike": label } }) }).catch(function () {});
    var fix = (C.raw && C.raw.items || []).filter(function (it) { return it.properties && it.properties._needs_bike && !it.properties.Bike; });
    fix.reduce(function (p, it) {
      return p.then(function () { var pr = Object.assign({}, it.properties, { Bike: label }); return fetch(cartUrl("/cart/change.js"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: pr }) }); });
    }, Promise.resolve()).then(function () { if (fix.length) C.refresh(); });
  });
  /* ---------- setup check: which product slots are linked (theme editor, or any page with ?af_check=1) ---------- */
  if (S.designMode || /[?&]af_check=1/.test(location.search)) {
    var LAB = { stack_ktm: "Stack kit: KTM / Husqvarna / GasGas", stack_yamaha: "Stack kit: Yamaha", stack_honda: "Stack kit: Honda", stack_beta: "Stack kit: Beta / Sherco",
      outerwear: "Replacement outerwear", fender_ktm: "Stubby fender (KTM)", rp_pipe: "RP pipe", tune: "Airforce tune", ecu: "AiM ECU", throttle_body: "Throttle body", cam: "Crower cam",
      kit_490: "490 kit", cyl_490: "490 cylinder", piston_490: "490 piston", head_gasket_490: "490 head gasket", base_gasket_490: "490 base gasket",
      baro: "Barometer", "switch": "ECU switch", bridge: "ECU bridge cable", rp_pipe_yamaha: "RP pipe (Yamaha, for later)" };
    var rows = Object.keys(LAB).map(function (k) {
      var pr = P[k], ok = pr && pr.variants && pr.variants.some(function (v) { return v.available; });
      var st = !pr ? ["no", "Not linked"] : ok ? ["ok", pr.title] : ["warn", pr.title + " · can't be bought (sold out)"];
      return '<li class="af-setcheck__' + st[0] + '"><b>' + AF.esc(LAB[k]) + "</b><span>" + AF.esc(st[1]) + "</span></li>";
    });
    var nNo = Object.keys(LAB).filter(function (k) { return !P[k]; }).length;
    var box = document.createElement("aside"); box.className = "af-setcheck"; box.setAttribute("aria-label", "Store setup check");
    box.innerHTML = '<div class="af-setcheck__head"><b>Setup check</b><span>' + (nNo ? nNo + " not linked" : "All linked") + '</span><button type="button" aria-label="Close setup check">×</button></div>' +
      '<p>Only you see this (theme editor or ?af_check=1). "Not linked" also shows for a product that is a draft or not on the Online Store sales channel. Sold out: turn on "Continue selling when out of stock", or turn off inventory tracking.</p><ul>' + rows.join("") + "</ul>";
    box.querySelector("button").addEventListener("click", function () { box.remove(); });
    var addBox = function () { document.body.appendChild(box); };
    if (document.body) addBox(); else document.addEventListener("DOMContentLoaded", addBox);
  }
})();
